<template>
  <div v-if="!isLoading && showForEntityTypes.includes(clickedEntityType)" class="overview">
    <div v-for="(item, index) in overviewData" :key="index" class="overview__row">
      <SvgDisplay :src="iconSource(item.itemType)" class="overview__row__icon" />
      <div>{{ item.itemValue }} {{ item.itemTitle.toLowerCase() }}</div>
    </div>
  </div>
  <div
    v-else-if="showForEntityTypes.includes(clickedEntityType)"
    style="width: 100%; height: 100px; display: flex; align-items: center; justify-content: center"
  >
    <PulseLoader :loading="true" color="#3F46D6" />
  </div>
</template>
<script lang="ts" setup>
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import SvgDisplay from '@/design-system/atoms/SvgDisplay.vue'

defineProps<{
  isLoading: boolean
  overviewData: { itemTitle: string; itemType: string; itemValue: string }[]
  showForEntityTypes: string[]
  title?: string
}>()

const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)

function iconSource(itemType: string) {
  switch (itemType) {
    case 'COMPLEX':
      return 'Icon-Levels-Complexes'
    case 'REAL_ESTATE':
      return 'Icon-Levels-Real-Estates-Small'
    case 'CONSTRUCTION':
      return 'Icon-Levels-Constructions'
    case 'LEVEL':
      return 'Icon-Levels-Floors-Small'
    case 'SPACE':
      return 'Icon-Levels-Rooms-Small'
    default:
      return 'Icon-Blank'
  }
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';

.overview {
  &__row {
    @include font-mixins.desktop-regular-paragraph;
    align-items: center;
    color: variables.$color-greyscale-content;
    display: flex;
    gap: 8px;
    padding-bottom: 8px;
    &__icon {
      color: variables.$color-greyscale-secondary;
      width: 16px;
    }
  }
}
</style>
